<template>
  <div class="principal-management">
    <el-form :inline="true" class="form-style" size="mini">
      <el-form-item>
        <el-button @click="addSoftware" type="primary" icon="el-icon-plus">添加客户端</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <div class="taglist">
          <el-tag type="success" @click="AddJr">Jrcode平板端</el-tag>
          <el-tag type="success" @click="AddPy">Python3.8.3编辑器</el-tag>
          <el-tag type="success" @click="AddPyZs">Python小助手slink</el-tag>
          <el-tag type="success" @click="chrome">chrome浏览器</el-tag>
          <el-tag type="success" @click="xrk">向日葵远程协助</el-tag>
          <el-tag type="success" @click="syxzs">实用小助手</el-tag>

        </div>
      </el-form-item>

    </el-form>
    <div class="table-style">
      <el-table size="mini" :data="schoolFileList" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column width="50" align="center" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.row.sort_num }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" width="100" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="scope.row.cover_url" fit="fill"></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="title" label="软件名称" width="200"></el-table-column>

        <el-table-column align="center" prop="content" label="介绍" width="200"></el-table-column>

        <el-table-column align="center" prop="file_one_title" label="附件1-名称" width="200"></el-table-column>

        <el-table-column align="center" prop="file_one_content" label="附件1-介绍" width="300"></el-table-column>
        <el-table-column align="center" label="附件1-文件" width="300">
          <template slot-scope="scope">
            <div v-for="(item, index) of JSON.parse(scope.row.file_one_arr)" :key="index">
              <span>名称:</span><span>{{ item.title }}</span> <span>地址:</span><span>{{ item.url }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="file_two_title" label="附件2-名称" width="200"></el-table-column>

        <el-table-column align="center" prop="file_two_content" label="附件2-介绍" width="200"></el-table-column>
        <el-table-column align="center" label="附件2-文件" width="200">
          <template slot-scope="scope">
            <div v-for="(item, index) of JSON.parse(scope.row.file_two_arr)" :key="index">
              <span>名称:</span><span>{{ item.title }}</span><br />
              <span>地址:</span><span>{{ item.url }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="created_time" label="创建时间" width="200"></el-table-column>

        <el-table-column align="center" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="EditFiles(scope.row)">编辑</el-button>

            <el-button type="text" size="mini" @click="DeleteFiles(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size"
        layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

    <el-dialog :title="form.schoolFileId ? '编辑信息' : '添加客户端'" :visible.sync="dialogVisible" width="800px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left"
        size="mini">
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number v-model="form.sort_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="软件名称" required prop="title">
          <el-input placeholder="请输入软件名称" v-model="form.title">
          </el-input>
        </el-form-item>

        <el-form-item label="封面" required prop="cover_url">
          <el-input placeholder="请输入封面地址" v-model="form.cover_url">
          </el-input>
        </el-form-item>

        <el-form-item label="说明" required prop="content">
          <el-input placeholder="请输入说明" v-model="form.content"> </el-input>
        </el-form-item>

        <el-form-item label="位置" required prop="area">
          <el-select v-model="form.area" placeholder="请选择" style="width: 150px">
            <el-option label="一区" :value="1"></el-option>
            <el-option label="二区" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="附件1名称">
          <el-input placeholder="请输入附件1名称" v-model="form.file_one_title">
          </el-input>
        </el-form-item>

        <el-form-item label="附件1二维码" prop="file_one_qrcode_url">
          <el-input placeholder="请输入二维码图片地址" v-model="form.file_one_qrcode_url">
          </el-input>
        </el-form-item>

        <el-form-item label="附件1说明" prop="file_one_content">
          <el-input placeholder="请输入说明" v-model="form.file_one_content">
          </el-input>
        </el-form-item>

        <el-form-item label="附件1文件">
          <el-button round class="el-icon-plus" size="mini" @click="AddFile('1')"></el-button>
        </el-form-item>

        <el-form-item v-for="(item, index) of form.file_one_arr" :key="index">
          <el-input size="mini" style="width: 200px" v-model="form.file_one_arr[index].title"
            placeholder="请输入软件名称"></el-input>

          <el-input size="mini" style="width: 200px; margin-left: 10px" v-model="form.file_one_arr[index].url"
            placeholder="请输入软件下载地址"></el-input>

          <span style="margin-left: 20px" class="el-icon-remove-outline" @click="DeleteFile(index, '1')"></span>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="附件2名称" prop="file_two_title">
          <el-input placeholder="请输入附件2名称" v-model="form.file_two_title">
          </el-input>
        </el-form-item>

        <el-form-item label="附件2二维码" prop="file_two_qrcode_url">
          <el-input placeholder="请输入二维码图片地址" v-model="form.file_two_qrcode_url">
          </el-input>
        </el-form-item>

        <el-form-item label="附件2说明" prop="file_two_content">
          <el-input placeholder="请输入说明" v-model="form.file_two_content">
          </el-input>
        </el-form-item>

        <el-form-item label="附件2文件">
          <el-button round class="el-icon-plus" size="mini" @click="AddFile('2')"></el-button>
        </el-form-item>

        <el-form-item v-for="(item, index) of form.file_two_arr" :key="index">
          <el-input size="mini" style="width: 200px" v-model="form.file_two_arr[index].title"
            placeholder="请输入软件名称"></el-input>

          <el-input size="mini" style="width: 200px; margin-left: 10px" v-model="form.file_two_arr[index].url"
            placeholder="请输入软件下载地址"></el-input>

          <span style="margin-left: 20px" class="el-icon-remove-outline" @click="DeleteFile(index, '2')"></span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminCreateOrUpdateSchoolFile,
  adminGetSchoolFileList,
  adminDeleteSchoolFile,
} from "@/api/admin";
export default {
  name: "download-management",
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogVisible1: false,

      form: {
        title: "",
        cover_url: "",
        content: "",
        sort_num: 1,
        area: 1,
        file_one_title: "",
        file_one_qrcode_url: "",
        file_one_content: "",
        file_one_arr: [],
        file_two_title: "",
        file_two_qrcode_url: "",
        file_two_content: "",
        file_two_arr: [],
        schoolId: "",
        schoolFileId: "",
      },
      userId: "",
      schoolFileList: [],
      educational_institution_list: [],

      total: 0,
      page_no: 1,
      page_size: 20,

      rules: {
        title: [
          {
            required: true,
            message: "请输入软件名称",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入软件名称",
            trigger: "change",
          },
        ],
        cover_url: [
          {
            required: true,
            message: "请输入录入封面地址",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入录入封面地址",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入说明",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入说明",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    if (!this.$route.query.id) {
      this.$message.warning("请选择学校");
      this.$router.push({
        name: "cooperative-school",
      });
      return;
    } else {
      this.form.schoolId = this.$route.query.id;
      this.adminGetSchoolFileList();
      console.log("学校ID");
      console.log(this.form.schoolId);
    }
  },
  methods: {
    //添加实用小助手
    syxzs() {
      adminCreateOrUpdateSchoolFile({
        sort_num: 100,
        title: '实用小助手',
        cover_url: 'https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/tools/002wuge_software/ad_%E5%AE%9E%E7%94%A8%E5%B0%8F%E5%8A%A9%E6%89%8B/aa_%E5%AE%A2%E6%88%B7%E7%AB%AF%E8%BD%AF%E4%BB%B6%E7%9B%B8%E5%85%B3/icon.png',

        content: '清理客户端软件缓存 | 修复客户端Python运行环境等问题',
        area: 2,
        file_one_title: '',
        file_one_qrcode_url: '',
        file_one_content: '',
        file_one_arr: JSON.stringify([
          { "title": "客户端小助手", "url": "https://huewq7h021.feishu.cn/wiki/wikcnyGpY6swbXXWqn13uPXmyKf" }
        ]),
        file_two_title: '',
        file_two_qrcode_url: '',
        file_two_content: '',
        file_two_arr: JSON.stringify([]),
        schoolId: this.form.schoolId,
      }).then((res) => {
        console.log("创建校区文件");
        console.log(res);
        if (res.is_create) {
          this.$message.success("添加成功");
          this.adminGetSchoolFileList();
        }
      });
    },
    //添加xrk
    xrk() {
      adminCreateOrUpdateSchoolFile({
        sort_num: 1,
        title: '向日葵远程协助',
        cover_url: 'https://wugecdn.steam.fun/resources/static/apps/xiangrikui.jpeg',

        content: '远程解决电脑问题,支持 Windows/Mac',
        area: 2,
        file_one_title: 'Windows 版 本 下 载',
        file_one_qrcode_url: '',
        file_one_content: '',
        file_one_arr: JSON.stringify([
          { "title": "Windows 64位", "url": "https://sunlogin.oray.com/download?categ=personal" }
        ]),
        file_two_title: 'Mac 版 本 下 载',
        file_two_qrcode_url: '',
        file_two_content: '',
        file_two_arr: JSON.stringify([
          { "title": "mac+", "url": "https://sunlogin.oray.com/download?categ=personal" }
        ]),
        schoolId: this.form.schoolId,
      }).then((res) => {
        console.log("创建校区文件");
        console.log(res);
        if (res.is_create) {
          this.$message.success("添加成功");
          this.adminGetSchoolFileList();
        }
      });
    },
    //添加chrome
    chrome() {
      adminCreateOrUpdateSchoolFile({
        sort_num: 1,
        title: 'chrome浏览器',
        cover_url: 'https://www.google.cn/chrome/static/images/chrome-logo.svg',

        content: '兼容性最好,支持 Windows/Mac',
        area: 2,
        file_one_title: '',
        file_one_qrcode_url: '',
        file_one_content: '',
        file_one_arr: JSON.stringify([
          { "title": "Windows 64位", "url": "https://www.google.cn/chrome/" }
        ]),
        file_two_title: 'Mac 版 本 下 载',
        file_two_qrcode_url: '',
        file_two_content: '',
        file_two_arr: JSON.stringify([
          { "title": "mac+", "url": "https://www.google.cn/chrome/" }
        ]),
        schoolId: this.form.schoolId,
      }).then((res) => {
        console.log("创建校区文件");
        console.log(res);
        if (res.is_create) {
          this.$message.success("添加成功");
          this.adminGetSchoolFileList();
        }
      });
    },
    //添加py助手
    AddPyZs() {
      adminCreateOrUpdateSchoolFile({
        sort_num: 1,
        title: 'Python小助手slink',
        cover_url: 'https://wugecdn.steam.fun/resources/static/apps/icon.png',

        content: '搭配Python网页版本使用,版本 V1.5.3,支持 Windows/Mac',
        area: 2,
        file_one_title: 'Windows 版 本 下 载',
        file_one_qrcode_url: '',
        file_one_content: 'Win7 或 Win10 (推荐 64 位系统）',
        file_one_arr: JSON.stringify([
          { "title": "Windows 64位", "url": "https://wugecdn.steam.fun/tools/1000software/ca_python/slink_1.0_win32.exe" }
        ]),
        file_two_title: 'Mac 版 本 下 载',
        file_two_qrcode_url: '',
        file_two_content: 'macOS 10.12+',
        file_two_arr: JSON.stringify([
          { "title": "macOS 10.12+", "url": "https://wugecdn.steam.fun/tools/1000software/ca_python/slink.dmg" }
        ]),
        schoolId: this.form.schoolId,
      }).then((res) => {
        console.log("创建校区文件");
        console.log(res);
        if (res.is_create) {
          this.$message.success("添加成功");
          this.adminGetSchoolFileList();
        }
      });
    },
    //添加py
    AddPy() {
      adminCreateOrUpdateSchoolFile({
        sort_num: 1,
        title: 'Python3.8.3编辑器',
        cover_url: 'https://wugecdn.steam.fun/resources/static/apps/python.png',

        content: '运行Python的必要条件,版本：3.8.3',
        area: 2,
        file_one_title: 'Windows 版 本 下 载',
        file_one_qrcode_url: '',
        file_one_content: 'Win7 或 Win10 (推荐 64 位系统）',
        file_one_arr: JSON.stringify([
          { "title": "Windows 64位", "url": "https://wugecdn.steam.fun/tools/1000software/ca_python/python-3.8.3rc1.exe" }
        ]),
        file_two_title: 'Mac 版 本 下 载',
        file_two_qrcode_url: '',
        file_two_content: 'macOS 10.12+ ',
        file_two_arr: JSON.stringify([
          { "title": "macOS 10.12+", "url": "https://wugecdn.steam.fun/tools/1000software/ca_python/python-3.8.3-macosx10.9.pkg" }
        ]),
        schoolId: this.form.schoolId,
      }).then((res) => {
        console.log("创建校区文件");
        console.log(res);
        if (res.is_create) {
          this.$message.success("添加成功");
          this.adminGetSchoolFileList();
        }
      });
    },
    //添加jr
    AddJr() {
      adminCreateOrUpdateSchoolFile({
        sort_num: 1,
        title: 'Jrcode平板端',
        cover_url: 'https://wugecdn.steam.fun/resources/static/apps/jrcode/jrcode.png',
        content: '支持Ipad和安卓平板',
        area: 1,
        file_one_title: 'Ipad扫码下载',
        file_one_qrcode_url: 'https://wugecdn.steam.fun/resources/static/apps/jrcode_ipad.png',
        file_one_content: '支持ios9.3以上',
        file_one_arr: JSON.stringify([]),
        file_two_title: '安卓扫码下载',
        file_two_qrcode_url: 'https://wugecdn.steam.fun/resources/static/apps/jrcode_android.png',
        file_two_content: '支持安卓6.0以上',
        file_two_arr: JSON.stringify([]),
        schoolId: this.form.schoolId,
      }).then((res) => {
        console.log("创建校区文件");
        console.log(res);
        if (res.is_create) {
          this.$message.success("添加成功");
          this.adminGetSchoolFileList();
        }
      });
    },
    addSoftware() {
      this.dialogVisible = true;
    },
    quitDialog() {
      this.dialogVisible = false;
    },
    //查询校区文件
    adminGetSchoolFileList() {
      if (!this.$route.query.id) {
        this.$message.warning("请选择学校");
        return;
      }

      adminGetSchoolFileList({
        searchType: "2",
        title: "",
        schoolId: this.form.schoolId,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("校区文件");
        console.log(res);
        this.schoolFileList = res.schoolFileList.dataList;
        this.total = res.schoolFileList.total;
      });
    },

    search() {
      this.page_no = 1;
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form);

          if (this.form.schoolFileId) {
            adminCreateOrUpdateSchoolFile({
              title: this.form.title,
              cover_url: this.form.cover_url,
              content: this.form.content,
              sort_num: this.form.sort_num,
              area: this.form.area,
              file_one_title: this.form.file_one_title,
              file_one_qrcode_url: this.form.file_one_qrcode_url,
              file_one_content: this.form.file_one_content,
              file_one_arr: JSON.stringify(this.form.file_one_arr),
              file_two_title: this.form.file_two_title,
              file_two_qrcode_url: this.form.file_two_qrcode_url,
              file_two_content: this.form.file_two_content,
              file_two_arr: JSON.stringify(this.form.file_two_arr),
              schoolId: this.form.schoolId,
              schoolFileId: this.form.schoolFileId,
            }).then((res) => {
              console.log("更新校区文件");
              console.log(res);
              if (res.is_update) {
                this.$message.success("修改成功");
                this.adminGetSchoolFileList();
                this.dialogVisible = false;
                this.form.schoolFileId = "";
              }
            });
          } else {
            adminCreateOrUpdateSchoolFile({
              title: this.form.title,
              cover_url: this.form.cover_url,
              content: this.form.content,
              sort_num: this.form.sort_num,
              area: this.form.area,
              file_one_title: this.form.file_one_title,
              file_one_qrcode_url: this.form.file_one_qrcode_url,
              file_one_content: this.form.file_one_content,
              file_one_arr: JSON.stringify(this.form.file_one_arr),
              file_two_title: this.form.file_two_title,
              file_two_qrcode_url: this.form.file_two_qrcode_url,
              file_two_content: this.form.file_two_content,
              file_two_arr: JSON.stringify(this.form.file_two_arr),
              schoolId: this.form.schoolId,
            }).then((res) => {
              console.log("创建校区文件");
              console.log(res);
              if (res.is_create) {
                this.$message.success("添加成功");
                this.adminGetSchoolFileList();
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },

    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetSchoolFileList();
    },

    AddFile(cmd) {
      console.log("添加文件");

      var file = {
        title: "",
        url: "",
      };
      if (cmd == "1") {
        this.form.file_one_arr.push(file);
      } else if (cmd == "2") {
        this.form.file_two_arr.push(file);
      }
    },

    EditFiles(row) {
      console.log("编辑文件");
      console.log(row);
      this.dialogVisible = true;
      this.form.schoolFileId = row.id;
      this.form.title = row.title;
      this.form.cover_url = row.cover_url;
      this.form.content = row.content;
      this.form.area = row.area;
      this.form.sort_num = row.sort_num;
      this.form.file_one_title = row.file_one_title;
      this.form.file_one_content = row.file_one_content;
      this.form.file_one_qrcode_url = row.file_one_qrcode_url;
      this.form.file_one_arr = JSON.parse(row.file_one_arr);

      this.form.file_two_title = row.file_two_title;
      this.form.file_two_content = row.file_two_content;
      this.form.file_two_qrcode_url = row.file_two_qrcode_url;
      this.form.file_two_arr = JSON.parse(row.file_two_arr);
    },

    DeleteFiles(row) {
      console.log("删除校区文件");
      console.log(row);

      this.$confirm("确定删除该文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteSchoolFile({
          schoolFileId: row.id,
        }).then((res) => {
          console.log("删除校区文件");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetSchoolFileList();
          }
        });
      });
    },

    DeleteFile(index, cmd) {
      if (cmd == "1") {
        this.form.file_one_arr.splice(index, 1);
      } else if (cmd == "2") {
        this.form.file_two_arr.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.principal-management {
  height: 100%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  margin: 10px;
  border-radius: 5px;
  background-color: #fff;

  .form-style {}

  .btn {
    margin-top: 10px;
  }
}

.taglist ::v-deep .el-tag {
  cursor: pointer;
  margin-right: 10px;
}
</style>
